import React, { useState, useEffect } from 'react';
import biruxComodin112 from '../images/biruxComodin112.png';
import biruxBronce112 from '../images/biruxBronce112.png';
import corazon64 from '../images/corazon64.png';
import cofre112 from '../images/cofre112v2.png';
import { checkAuthError } from '../../utils/sessionUtils';

// Desglose de probabilidades de la Overbox. Los porcentajes NO se escriben aqui: vienen de
// /api/overboxOdds, que los calcula con las mismas tablas y el mismo pool de recompensas
// que usa el sorteo. Duplicarlos en el front dejaria de ser cierto en cuanto alguien tocase
// las tablas del servidor o el autobalanceo moviese los precios, y esto es informacion de
// obligada transparencia.

const TYPE_IMAGES = {
    biruxComodin: biruxComodin112,
    birux: biruxBronce112,
    vidas: corazon64
};

const formatPct = (value) => {
    if (!value) return '0%';
    const decimals = value >= 1 ? 2 : value >= 0.01 ? 4 : 6;
    return value.toFixed(decimals).replace(/0+$/, '').replace(/\.$/, '') + '%';
};

const formatAmount = (value) => value.toLocaleString('es-ES');

// mini: las de la Mini Overbox, que tiene su propia tabla de tipos.
const OverboxOddsModal = ({ onClose, mini }) => {
    const boxName = mini ? 'Mini Overbox' : 'Overbox';
    const [odds, setOdds] = useState(null);
    const [error, setError] = useState(null);
    const [openRarity, setOpenRarity] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    useEffect(() => {
        let cancelled = false;

        const loadOdds = async () => {
            try {
                const response = await fetch('/api/overboxOdds' + (mini ? '?mini=1' : ''), { credentials: 'include' });
                const data = await response.json();
                if (cancelled) return;
                if (data.success) {
                    setOdds(data);
                } else if (!checkAuthError(data)) {
                    setError('No se pudieron cargar las probabilidades.');
                }
            } catch (err) {
                if (!cancelled) setError('Error de red al cargar las probabilidades.');
            }
        };

        loadOdds();
        return () => { cancelled = true; };
    }, [mini]);

    const chanceOf = (rarityKey, typeKey) => {
        const cell = odds.matrix.find(entry => entry.rarity === rarityKey && entry.type === typeKey);
        return cell || { chance: 0, min: null, max: null };
    };

    const rewardsOf = (rarityKey) => odds.rewards.filter(item => item.rarity === rarityKey);

    return (
        <div className='overboxGetMoreOverlay' onClick={onClose}>
            <div className='PopUp heroes overboxOddsPopUp' onClick={(e) => e.stopPropagation()}>
                <span className='PopUpClose' onClick={onClose}>X</span>
                <div className='PopUpTitle'><h3>Probabilidades de la {boxName}</h3></div>

                <div className='overboxOddsBody'>
                    {!odds && !error && <div className='overboxOddsState'>Cargando probabilidades...</div>}
                    {error && <div className='overboxOddsState overboxOddsError'>{error}</div>}

                    {odds && (
                        <>
                            <p className='overboxOddsIntro'>
                                Cada {boxName} hace <strong>dos tiradas independientes</strong>: una decide la
                                rareza del premio y otra decide qué tipo de premio es. Cada apertura es
                                independiente de las anteriores: no hay rachas ni contadores.
                                {odds.types.filter(type => type.rarity).map(type => (
                                    <span key={type.key}> Si el premio es de {type.label}, la tirada de rareza no cuenta:
                                        siempre es {(odds.rarities.find(r => r.key === type.rarity) || {}).label}
                                        {!mini && ', salvo que salga Delirio'}.</span>
                                ))}
                                {!mini && <> Si la rareza es Delirio, el premio siempre es una recompensa de Birux
                                    Comodín de 1 € o más, salga el tipo que salga, Arena incluida, y cuanto más vale
                                    más cuesta que toque: una de 30 € sale 30 veces menos que una de 1 €. Solo entran
                                    las que caben en el presupuesto de recompensas que queda este mes, y si no cabe
                                    ninguna se queda en Locura.</>}
                            </p>

                            <div className='overboxOddsSection'>
                                <div className='overboxOddsSectionTitle'>1. Rareza del premio</div>
                                <table className='overboxOddsTable'>
                                    <tbody>
                                        {odds.rarities.map(rarity => (
                                            <tr key={rarity.key}>
                                                <td className={`overboxOddsTier overboxOddsTier-${rarity.key}`}>{rarity.label}</td>
                                                <td className='overboxOddsValue'>{formatPct(rarity.chance)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className='overboxOddsSection'>
                                <div className='overboxOddsSectionTitle'>2. Tipo de premio</div>
                                <table className='overboxOddsTable'>
                                    <tbody>
                                        {odds.types.map(type => (
                                            <tr key={type.key}>
                                                <td>
                                                    {TYPE_IMAGES[type.key] && (
                                                        <img className='overboxOddsIcon' src={TYPE_IMAGES[type.key]} alt={type.label} />
                                                    )}
                                                    {type.label}
                                                </td>
                                                <td className='overboxOddsValue'>{formatPct(type.chance)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className='overboxOddsSection'>
                                <div className='overboxOddsSectionTitle'>3. Probabilidad de cada premio</div>
                                <div className='overboxOddsScroll'>
                                    <table className='overboxOddsTable overboxOddsMatrix'>
                                        <thead>
                                            <tr>
                                                <th>Rareza</th>
                                                {odds.types.map(type => <th key={type.key}>{type.label}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {odds.rarities.map(rarity => (
                                                <tr key={rarity.key}>
                                                    <td className={`overboxOddsTier overboxOddsTier-${rarity.key}`}>{rarity.label}</td>
                                                    {odds.types.map(type => {
                                                        const cell = chanceOf(rarity.key, type.key);
                                                        return (
                                                            <td key={type.key} className='overboxOddsValue'>
                                                                {formatPct(cell.chance)}
                                                                {cell.min != null && (
                                                                    <span className='overboxOddsRange'>
                                                                        {cell.min === cell.max ? formatAmount(cell.min) : `${formatAmount(cell.min)} - ${formatAmount(cell.max)}`}
                                                                    </span>
                                                                )}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <p className='overboxOddsHint'>
                                    En los premios de Birux y de la Arena (combates), la cifra de debajo es la
                                    cantidad que puedes recibir, repartida por igual dentro de ese rango.
                                </p>
                            </div>

                            <div className='overboxOddsSection'>
                                <div className='overboxOddsSectionTitle'>4. Recompensas que pueden tocarte</div>
                                {odds.rewards.length === 0 ? (
                                    <p className='overboxOddsHint'>Ahora mismo no hay recompensas disponibles en el sorteo.</p>
                                ) : odds.rarities.map(rarity => {
                                    const items = rewardsOf(rarity.key);
                                    if (items.length === 0) return null;
                                    const total = items.reduce((sum, item) => sum + item.chance, 0);
                                    const isOpen = openRarity === rarity.key;
                                    return (
                                        <div className='overboxOddsGroup' key={rarity.key}>
                                            <div
                                                className='overboxOddsGroupHead'
                                                onClick={() => setOpenRarity(isOpen ? null : rarity.key)}
                                            >
                                                <span className={`overboxOddsTier overboxOddsTier-${rarity.key}`}>{rarity.label}</span>
                                                <span className='overboxOddsGroupMeta'>
                                                    {items.length} recompensa{items.length === 1 ? '' : 's'} · {formatPct(total)}
                                                </span>
                                                <span className='overboxOddsGroupArrow'>{isOpen ? '−' : '+'}</span>
                                            </div>
                                            {isOpen && (
                                                <div className='overboxOddsGroupList'>
                                                    {items.map((item, index) => (
                                                        <div className='overboxOddsReward' key={`${item.name}-${index}`}>
                                                            <img
                                                                src={`/images/rewards/${item.image}`}
                                                                alt={item.name}
                                                                onError={(e) => { e.target.src = cofre112; }}
                                                            />
                                                            <span className='overboxOddsRewardName'>{item.name}</span>
                                                            <span className='overboxOddsValue'>{formatPct(item.chance)}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className='overboxOddsNote'>
                                <p>
                                    Estos porcentajes se calculan sobre el catálogo de recompensas activo en
                                    este momento y cambian cuando se añaden, se retiran o se reajustan de
                                    precio recompensas.
                                </p>
                                <p>
                                    Las recompensas que pueden tocarte dependen de tu facción, y la tuya es
                                    <strong> {odds.faction}</strong>.
                                </p>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OverboxOddsModal;
